import {moment} from "../xlib"

export default {
    setUserAuthToken(state, authToken) {
        state.user.authToken = authToken;
    },
    removeUserAuthToken(state){
        state.user.authToken = null;
    },
    setUserInfo(state, info) {
        info.monthYearJoinedStr = moment(info.dateJoined).format('LL');
        state.user.info = info;
    },
    addUserPinnedPost(state, postNode){
        state.user.info.postPinnedSet.edges.push({node: postNode, __typename: "PostNodeEdge"})
    },
    removeUserPinnedPost(state, postNode){
        let postNodes = state.user.info.postPinnedSet.edges

        function isPostToRemove(_postNode) {
            return _postNode.id === postNode.id;
        }
        let postNodeToRemoveIdx = postNodes.findIndex(isPostToRemove);
        postNodes.splice(postNodeToRemoveIdx, 1);
    },
    setUserAvatar(state, avatarUrl){
        state.user.info.profile.avatarUrl = avatarUrl;
    }
};
